import { render } from "./linkedInClassic.vue?vue&type=template&id=23a049b0"
import script from "./linkedInClassic.vue?vue&type=script&lang=js"
export * from "./linkedInClassic.vue?vue&type=script&lang=js"

import "./linkedInClassic.vue?vue&type=style&index=0&id=23a049b0&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__